import { render } from "./Page404.vue?vue&type=template&id=34af3b48&ts=true"
import script from "./Page404.vue?vue&type=script&lang=ts"
export * from "./Page404.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__